import { Validation } from 'ts/interfaces/Validation';
import i18n from 'i18next';
import {
  faUsd,
  faEur,
  faGbp,
  faCrown,
  faArrowUp19,
  faStar,
  faArrowUpAZ,
  faArrowDownLong,
  faArrowUpLong,
  faArrowDownZA,
  faArrowDown91,
} from '@fortawesome/free-solid-svg-icons';
import { Select } from 'ts/interfaces/Generic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDownLeftAndArrowUpRightToCenter,
  faArrowUpRightAndArrowDownLeftFromCenter,
} from '@fortawesome/sharp-duotone-solid-svg-icons';
import FontAwesomeLayered from 'components/shared/ui/FontAwesomeLayered';
import { User } from 'ts/shared/interfaces/User';

export const imgFolder = '/backend/s3/prod.beprotravel/cdn/';
export const shortPassengerValidation: Validation = {
  gender: { required: true },
  firstName: { required: true, minLength: 2, maxLength: 20, english: true },
  lastName: { maxLength: 20, english: true },
};

export const passengerValidation: Validation = {
  firstName: { required: true, minLength: 2, maxLength: 20, english: true },
  lastName: { required: true, minLength: 2, maxLength: 20, english: true },
  email: { required: true, email: true },
  phone: { required: true },
};

export const titlePassengerOptions = [
  { value: 'mr', label: 'passenger.mr' },
  { value: 'mrs', label: 'passenger.mrs' },
  { value: 'miss', label: 'passenger.miss' },
  { value: 'ms', label: 'passenger.ms' },
  { value: 'dr', label: 'passenger.dr' },
  { value: 'prof', label: 'passenger.prof' },
];

export const sexOptions = [
  { value: 'M', label: 'male' },
  { value: 'F', label: 'female' },
];

export const currenciesList: Select[] = [
  {
    value: 'usd',
    label: '',
    icon: {
      path: faUsd,
      className: '',
    },
  },
  {
    value: 'eur',
    label: '',
    icon: {
      path: faEur,
      className: '',
    },
  },
  {
    value: 'gbp',
    label: '',
    icon: {
      path: faGbp,
      className: '',
    },
  },
];

export const getPriceModesList = (user: User): Select[] => {
  let result = [
    {
      value: '0',
      label: 'Reg',
      html: <span className="text-bold text-sm">Reg</span>,
    },
  ];

  if (user.showLLV) {
    result.push({
      value: '1',
      label: 'Net',
      html: <span className="text-bold text-sm text-darkviolet">Net</span>,
    });
  }

  if (user.showMV) {
    result.push({
      value: '2',
      label: 'Net.Ð¢',
      html: <span className="text-bold text-sm text-success">Net.Ð¢</span>,
    });
  }

  return result;
};

export const topCategories = ['deluxe', 'superior', 'premium', 'classic', 'family', 'executive'];
export const topBed = ['king', 'twin', 'queen', 'double', 'full bed', 'sofa'];
export const topType = ['apartment', 'suite', 'studio', 'junior', 'loft'];


export const getGenderString = (input: string) => {
  if (input === 'M') {
    return i18n.t('passenger.male');
  } else if (input === 'F') {
    return i18n.t('passenger.female');
  }
  return '';
};
export enum RoomColors {
  cat = '#e3effe',
  vew = '#caf2c7',
  brd = '#ccc',
  grp = '#e0d1ec',
  default = '#fff',
}
export const getSortHotelOptions = (t: any): Select[] => {
  return [
    {
      value: 'recommended',
      label: t('sort.recommended'),
      html: (
        <div>
          <FontAwesomeLayered
            icon1={faArrowUpLong}
            icon2={faCrown}
            className="mr-10 text-success"
          />
          {t('sort.recommended')}
        </div>
      ),
    },
    {
      value: 'priceIncrease',
      label: t('price'),
      html: (
        <div>
          <FontAwesomeIcon icon={faArrowUp19} className="mr-10 text-success" />
          {t('sort.price_increase')}
        </div>
      ),
    },
    {
      value: 'priceDecrease',
      label: t('price'),
      html: (
        <div>
          <FontAwesomeIcon icon={faArrowDown91} className="mr-10 color-danger" />
          {t('sort.price_decrease')}
        </div>
      ),
    },
    {
      value: 'starIncrease',
      label: t('sort.star'),
      html: (
        <div>
          <FontAwesomeLayered icon1={faArrowUpLong} icon2={faStar} className="mr-10 text-success" />
          {t('sort.star_increase')}
        </div>
      ),
    },
    {
      value: 'starDecrease',
      label: t('sort.star'),
      html: (
        <div>
          <FontAwesomeLayered
            icon1={faArrowDownLong}
            icon2={faStar}
            className="mr-10 color-danger"
          />
          {t('sort.star_decrease')}
        </div>
      ),
    },
    {
      value: 'nameIncrease',
      label: t('sort.name'),
      html: (
        <div>
          <FontAwesomeIcon icon={faArrowUpAZ} className="mr-10 text-success" />
          {t('sort.hotel_increase')}
        </div>
      ),
    },
    {
      value: 'nameDecrease',
      label: t('sort.name'),
      html: (
        <div>
          <FontAwesomeIcon icon={faArrowDownZA} className="mr-10 color-danger" />
          {t('sort.hotel_decrease')}
        </div>
      ),
    },
    {
      value: 'distanceIncrease',
      label: t('sort.distance'),
      html: (
        <div>
          <FontAwesomeLayered
            icon1={faArrowUpLong}
            icon2={faArrowUpRightAndArrowDownLeftFromCenter}
            className="mr-10 text-success"
          />
          {t('sort.distance_increase')}
        </div>
      ),
    },
    {
      value: 'distanceDecrease',
      label: t('sort.distance'),
      html: (
        <div>
          <FontAwesomeLayered
            icon1={faArrowDownLong}
            icon2={faArrowDownLeftAndArrowUpRightToCenter}
            className="mr-10 color-danger"
          />
          {t('sort.distance_decrease')}
        </div>
      ),
    },
  ];
};

export const searchTypeIds: Select[] = [
  { value: 138, label: 'DEFAULT' },
  { value: 120, label: 'M+GTO' },
  { value: 162, label: 'M+EH' },
  { value: 165, label: 'M+EHT' },
  { value: 170, label: 'M+GTOEH' },
  { value: 105, label: 'PREFERRED' },
  { value: 1, label: 'ALL' },
  { value: 141, label: 'M+E' },
];

export const flyeastCompanyId = 108;
export const moManualRoomTypeOptions = [
  { value: 'O1A0C', label: 'O1A0C - 1 Adult', data: { numAdt: 1, numCnn: 0 } },
  { value: 'O2A0C', label: 'O2A0C - 2 Adults', data: { numAdt: 2, numCnn: 0 } },
  { value: 'O2A1C', label: 'O2A1C - 2 Adults plus 1 Child', data: { numAdt: 2, numCnn: 1 } },
  { value: 'O2A2C', label: 'O2A2C - 2 Adults plus 2 Children', data: { numAdt: 2, numCnn: 2 } },
  { value: 'O2A3C', label: 'O2A3C - 2 Adults plus 3 Children', data: { numAdt: 2, numCnn: 3 } },
  { value: 'O2A4C', label: 'O2A4C - 2 Adults plus 4 Children', data: { numAdt: 2, numCnn: 4 } },
  { value: 'O3A0C', label: 'O3A0C - 3 Adults', data: { numAdt: 3, numCnn: 0 } },
  { value: 'O3A1C', label: 'O3A1C - 3 Adults plus 1 Child', data: { numAdt: 3, numCnn: 1 } },
  { value: 'O3A2C', label: 'O3A2C - 3 Adults plus 2 Children', data: { numAdt: 3, numCnn: 2 } },
  { value: 'O3A3C', label: 'O3A3C - 3 Adults plus 3 Children', data: { numAdt: 3, numCnn: 3 } },
  { value: 'O3A4C', label: 'O3A4C - 3 Adults plus 4 Children', data: { numAdt: 3, numCnn: 4 } },
  { value: 'O4A0C', label: 'O4A0C - 4 Adults', data: { numAdt: 4, numCnn: 0 } },
  { value: 'O4A1C', label: 'O4A1C - 4 Adults plus 1 Child', data: { numAdt: 4, numCnn: 1 } },
  { value: 'O4A2C', label: 'O4A2C - 4 Adults plus 2 Children', data: { numAdt: 4, numCnn: 2 } },
  { value: 'O4A3C', label: 'O4A3C - 4 Adults plus 3 Children', data: { numAdt: 4, numCnn: 3 } },
  { value: 'O4A4C', label: 'O4A4C - 4 Adults plus 4 Children', data: { numAdt: 4, numCnn: 4 } },
  { value: 'O5A0C', label: 'O5A0C - 5 Adults', data: { numAdt: 5, numCnn: 0 } },
  { value: 'O5A1C', label: 'O5A1C - 5 Adults plus 1 Child', data: { numAdt: 5, numCnn: 1 } },
  { value: 'O5A2C', label: 'O5A2C - 5 Adults plus 2 Children', data: { numAdt: 5, numCnn: 2 } },
  { value: 'O5A3C', label: 'O5A3C - 5 Adults plus 3 Children', data: { numAdt: 5, numCnn: 3 } },
  { value: 'O5A4C', label: 'O5A4C - 5 Adults plus 4 Children', data: { numAdt: 5, numCnn: 4 } },
  { value: 'O6A0C', label: 'O6A0C - 6 Adults', data: { numAdt: 6, numCnn: 0 } },
  { value: 'O6A1C', label: 'O6A1C - 6 Adults plus 1 Child', data: { numAdt: 6, numCnn: 1 } },
  { value: 'O6A2C', label: 'O6A2C - 6 Adults plus 2 Children', data: { numAdt: 6, numCnn: 2 } },
  { value: 'O6A3C', label: 'O6A3C - 6 Adults plus 3 Children', data: { numAdt: 6, numCnn: 3 } },
  { value: 'O6A4C', label: 'O6A4C - 6 Adults plus 4 Children', data: { numAdt: 6, numCnn: 4 } },
  { value: 'O7A0C', label: 'O7A0C - 7 Adults', data: { numAdt: 7, numCnn: 0 } },
  { value: 'O7A1C', label: 'O7A1C - 7 Adults plus 1 Child', data: { numAdt: 7, numCnn: 1 } },
  { value: 'O7A2C', label: 'O7A2C - 7 Adults plus 2 Children', data: { numAdt: 7, numCnn: 2 } },
  { value: 'O7A3C', label: 'O7A3C - 7 Adults plus 3 Children', data: { numAdt: 7, numCnn: 3 } },
  { value: 'O7A4C', label: 'O7A4C - 7 Adults plus 4 Children', data: { numAdt: 7, numCnn: 4 } },
  { value: 'O8A0C', label: 'O8A0C - 8 Adults', data: { numAdt: 8, numCnn: 0 } },
  { value: 'O8A1C', label: 'O8A1C - 8 Adults plus 1 Child', data: { numAdt: 8, numCnn: 1 } },
  { value: 'O8A2C', label: 'O8A2C - 8 Adults plus 2 Children', data: { numAdt: 8, numCnn: 2 } },
  { value: 'O8A3C', label: 'O8A3C - 8 Adults plus 3 Children', data: { numAdt: 8, numCnn: 3 } },
  { value: 'O8A4C', label: 'O8A4C - 8 Adults plus 4 Children', data: { numAdt: 8, numCnn: 4 } },
];